/* eslint-disable @typescript-eslint/no-explicit-any */
export interface Question {
    order: number;
    locale: string;
    description?: string;
    name: string;
    required: boolean;
    type: QuestionType;
    maxLength: number;
    choices: Choice[]
    questions?: Question[],
    parentResponse: any,
    answer?: string
}
export interface Choice {
    locale: string;
    label: string;
    value: any;
}
export enum QuestionType {
    MULTI_CHOICE = "QUESTION_MULTI_CHOICE",
    TEXT = "QUESTION_TEXT",
    NUMERIC = "QUESTION_NUMERIC",
    RATING = "QUESTION_RATING"
}

export function mergeQuestions(multiple: Question[][]) {
    let questions = multiple.flat();
    let deduplicate: {[k: string]: Question} = {};
    questions.forEach(q => deduplicate[lookupKey(q)] = q);
    return Object.values(deduplicate);
}

function lookupKey(question: Question): any {
    return JSON.stringify(question, (key, value) => {
        if (key === 'order') return undefined;
        if (key === 'questions' && Array.isArray(value)) return value.map(lookupKey);
        return value;
    });
}